export const environment = {
  production: true,
  baseApiUrl: 'https://prodapi.avaana.com.au',
  baseCorporateWellbeingUrl: 'https://corporate-wellbeing.avaana.com.au',
  baseLogicHeathApiUrl: 'https://api-logichealth.avaana.com.au',
  baseEMLWorkcoverUrl: 'https://api-eml.avaana.com.au',
  baseTRINITYWorkcoverUrl: 'https://api-trinity.avaana.com.au',
  baseHIIWorkcoverUrl: 'https://api-hii.avaana.com.au',
  baseBlogUrl: 'https://avaana.com.au/blog'
};
